import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ltcs-claim-prefer-notice__body" }
const _hoisted_2 = {
  key: 0,
  class: "ltcs-claim-prefer-notice__title"
}
const _hoisted_3 = { class: "ltcs-claim-prefer-notice__text" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LtcsClaimDetailPreferNotice',
  props: {
    portalRawCount: { default: 0 },
    displayCount: { default: 0 },
    statusPairCount: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

const hasPairs = computed(() => Number(props.statusPairCount) > 0);

const formatCount = (value?: number) => Number(value || 0).toLocaleString();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ltcs-claim-prefer-notice", { 'ltcs-claim-prefer-notice--pairs': hasPairs.value }])
  }, [
    _createVNode(_component_v_icon, { size: "18" }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("mdi-information-outline", -1)
      ]))]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      (hasPairs.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 자동가져오기가 두 번 된 것이 아닙니다 "))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, [
        _cache[1] || (_cache[1] = _createTextVNode(" 롱텀케어 포털은 같은 방문을 ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ltcs-claim-prefer-notice__status" }, "청구의뢰", -1)),
        _cache[3] || (_cache[3] = _createTextVNode("와 ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ltcs-claim-prefer-notice__status ltcs-claim-prefer-notice__status--paid" }, "지급", -1)),
        _cache[5] || (_cache[5] = _createTextVNode(" 두 줄로 보여 줍니다. ", -1)),
        (hasPairs.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" 포털 원본 " + _toDisplayString(formatCount(__props.portalRawCount)) + "줄 중 같은 방문 " + _toDisplayString(formatCount(__props.statusPairCount)) + "건은 지급만 남겼습니다. 아래 목록·수가 합계는 방문 " + _toDisplayString(formatCount(__props.displayCount)) + "건입니다. ", 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" 둘 다 있으면 지급만 집계합니다. 아래 숫자는 방문 기준입니다. ")
            ], 64))
      ])
    ])
  ], 2))
}
}

})